module.exports = __webpack_public_path__ + "assets/images/4457de6c497259b2be6a188c3bf99fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/codewars-logo.png
// module id = 822
// module chunks = 0